import React, { useEffect, useMemo, useState } from "react";
import { ButtonGroup, Container, ToggleButton } from "react-bootstrap";
import './Admin.css';
import { Link } from "react-router-dom";
import 'react-confirm-alert/src/react-confirm-alert.css';
import DataTable from "react-data-table-component";
import FilterComponent from "../Common/FilterComponent";
import TopHeader from "../Common/TopHeader";
import AppLoaderTable from "../Apploader/AppLoaderTable";
import { CheckPropertyExistOrNot, GetApiMethod } from "../../core/services/apiService";
import TooltipPositioned from "../Common/TooltipPositioned";

const VendorAdminTable = () => {

    const [data, setData] = useState([]);
    const [listvendors, setListvendors] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [statusFilter, setStatusFilter] = useState("active");

    const statusOptions = [
        { name: "Active", value: "active" },
        { name: "Inactive", value: "inactive" },
        { name: "All", value: "all" },
    ];

    const columns: any = [
        {
            name: 'Name',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'name'),
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'email'),
            cell: (row: any) => TooltipPositioned({ position: 'top', item: CheckPropertyExistOrNot(row, 'email') }),
            sortable: true,
        },
        {
            name: 'Customer',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'name', 'vendor'),
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row: any) => ((CheckPropertyExistOrNot(row, 'isActive') === true ? "Active" : (CheckPropertyExistOrNot(row, 'isActive') === false ? "Inactive" : "-"))),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row: any) => (
                <div>
                    <Link to={'/customer-admin/edit'} state={{ id: row._id, names: row.name, emails: row.email, vendors: row.vendor, customerId: row.vendor?._id, vendorsList: listvendors, is_active: row.isActive }}><i className="fa fa-edit text-primary" style={{ fontSize: 24, marginRight: 15 }}></i></Link>
                    {/* <i className="fa fa-trash text-danger hover" onClick={(e) => { handleDelete(row._id, row.name) }} style={{ fontSize: 24 }}></i> */}
                </div>
            )
        },

    ];

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <div className="status-filter-wrapper">
                <ButtonGroup className="status-filter-group">
                    {statusOptions.map((option) => (
                        <ToggleButton
                            key={option.value}
                            id={`vendor-admin-status-filter-${option.value}`}
                            type="radio"
                            name="vendorAdminStatusFilter"
                            value={option.value}
                            checked={statusFilter === option.value}
                            onChange={(e) => setStatusFilter(e.currentTarget.value)}
                            className="status-filter-btn"
                        >
                            {option.name}
                        </ToggleButton>
                    ))}
                </ButtonGroup>
                <FilterComponent
                    onFilter={(e: any) => setFilterText(e.target.value)}
                    onClear={handleClear}
                    filterText={filterText}
                />
            </div>
        );
    }, [filterText, resetPaginationToggle, statusFilter]);

    const filteredItems = data?.filter((item: any) =>
            statusFilter === "all" ? true
                : statusFilter === "active" ? item.isActive === true
                : item.isActive === false
        )
        ?.filter(
            (item: any) =>
                JSON.stringify([item.name, item.email, item.vendor?.name, (item.isActive ? "Active" : "Inactive")])
                    .toLowerCase()
                    .indexOf(filterText.toLowerCase()) !== -1
        );


    useEffect(() => {

        GetApiMethod('admin/user/', { params: { role: 'vendor_admin' } }).then((res) => {
            setShowLoader(false);
            setData(res.data.data);
        })

        GetApiMethod('admin/vendor/', { params: { filter_type: 'dropdown' } }).then((res) => {
            setListvendors(res.data.data);
        })

    }, []);

    return (
        <>
            <Container fluid  >
                <div className="mt-3">
                    <TopHeader
                        heading={"Customer Admin"}
                        to={"/customer-admin/create"}
                        className="fa-plus"
                        action="Add"
                        id="add-customer-admin"
                    />

                    <DataTable
                        progressPending={showLoader}
                        progressComponent={<AppLoaderTable />}
                        columns={columns}
                        data={filteredItems}
                        pagination
                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        highlightOnHover
                        subHeader
                        persistTableHead
                        subHeaderComponent={subHeaderComponent}
                    />
                </div>
            </Container>
        </>
    )
}

export default VendorAdminTable;